import Track from '../../../../v2/utils/tracking';
import {getMobileOSName} from '../../../../v2/utils/user-agent';
import doMetric from '../../../../v2/tracking/bigQueryMetricRecorder';
import attributes from '../../../../v2/tracking/attributes';
import openLink from './openLink';

export const getSocialChannelAction = ({
  socialChannel,
  message,
  inwardReferralUrl,
  inwardSiteUrl,
}) => {
  const encodedMessage = encodeURIComponent(message || '');
  const encodedInwardReferralUrl = encodeURIComponent(inwardReferralUrl);
  const os = getMobileOSName();
  const attribute = [attributes.getAttribute('channelName', socialChannel.channel)];
  const bqEventSubtype = 'clickSocialSharing';

  switch (socialChannel.channel) {
    case 'EMAIL':
      return () => {
        openLink(socialChannel.additionalProperties.url);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'GOOGLE_PLUS':
      return () => {
        openLink(`https://plus.google.com/share?url=${encodedInwardReferralUrl}%26gp`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'TWITTER':
      return () => {
        openLink(`https://twitter.com/intent/tweet?text=${encodedMessage} ${encodedInwardReferralUrl}%26tw`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'VK':
      return () => {
        openLink(`http://vk.com/share.php?url=${encodedInwardReferralUrl}%26vk`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'WEIBO':
      return () => {
        openLink(`http://service.weibo.com/share/share.php?url=${encodedInwardReferralUrl}%26we&appkey=&title=${encodedMessage}&pic=&ralateUid=&language=zh_cn`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'WHATSAPP':
      return () => {
        openLink(`whatsapp://send?text=${encodedMessage} - ${encodedInwardReferralUrl}%26wa`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'FACEBOOK':
      return () => {
        openLink(`https://www.facebook.com/dialog/feed?app_id=${socialChannel.additionalProperties.appId}&display=popup&caption=${encodedMessage}&link=${encodedInwardReferralUrl}%26fbs`);
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'MESSENGER':
      return () => {
        if (os === 'iOS' || os === 'Android') {
          openLink(`fb-messenger://share?link=${encodedInwardReferralUrl}%26fbm`);
        } else {
          openLink(`https://www.facebook.com/dialog/send?app_id=${socialChannel.additionalProperties.appId}&link=${encodedInwardReferralUrl}%26fbm&redirect_uri=${inwardSiteUrl}`);
        }
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    case 'SMS':
      return () => {
        if (os === 'iOS') {
          openLink(`sms:&body=${encodedInwardReferralUrl}%26sm`);
        } else {
          const messageAndInwardReferralUrl = encodeURIComponent(`${message || ''} - ${inwardReferralUrl}&sm`);
          openLink(`sms:?body=${messageAndInwardReferralUrl}`);
        }
        try {
          doMetric(bqEventSubtype, attribute);
        } catch (error) {
          Track.track(error);
        }
      };
    default:
      return () => {
        Track.error(`Unknown social-sharing channel: ${socialChannel.channel}`);
      };
  }
};

export default getSocialChannelAction;
